var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 607,
    height: 488,
    viewBox: "0 0 607 488",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.746 9.06335L0 463.985L332.702 656L607 181.076L293.253 0L290.997 3.90558L600.837 182.726L331.05 649.839L6.16273 462.334L266.653 11.3182L262.746 9.06335Z",
    fill: "#5A9BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRectangle);
export default __webpack_public_path__ + "static/media/bottom_rectangle.d511eacf94625e3c8a3098686e77b729.svg";
export { ForwardRef as ReactComponent };